import { type ComponentPropsWithoutRef, memo } from 'react';

import { Command } from '@air/cmdk';
import { cn } from '@air/utils-tailwind';

export type SearchCommandItemProps = ComponentPropsWithoutRef<typeof Command.Item>;

export const SearchCommandItem = memo(({ className, ...restOfProps }: SearchCommandItemProps) => {
  return (
    <Command.Item
      className={cn(
        'group/command-item flex cursor-pointer items-center gap-2 rounded-4 p-2 text-14 transition-colors hover:bg-grey-4 data-[selected=true]:bg-grey-4',
        className,
      )}
      data-testid="SEARCH_COMMAND_ITEM"
      {...restOfProps}
    />
  );
});

SearchCommandItem.displayName = 'SearchCommandItem';
